import React from "react";
import Swap from "./Swap";

function App() {
  return <Swap />;
}

export default App;
